var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.83366 13.8333L4.00033 10L7.83366 6.16667L6.66699 5L1.66699 10L6.66699 15L7.83366 13.8333ZM12.167 13.8333L16.0003 10L12.167 6.16667L13.3337 5L18.3337 10L13.3337 15L12.167 13.8333Z",
    fill: "#42526E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlReport);
export default __webpack_public_path__ + "static/media/html_report.ccb6384fe8e8895985707e46f4d7a623.svg";
export { ForwardRef as ReactComponent };